import generateRender from '../../utils/generateRender';
import { pwaStyleAdapter } from '../../../web/src/utils/mobileSupported';
import { isMobile, isTablet } from 'react-device-detect';
export var height = generateRender({
  default: pwaStyleAdapter(5, 'rem'),
  sga: isMobile && !isTablet ? '6rem' : pwaStyleAdapter(5, 'rem')
});